var $cursors = {
  // ======================================================================
  // VARS
  // ======================================================================

  x: -100,
  y: -100,

  // ======================================================================
  // INIT
  // ======================================================================

  init: function() {
    $('body').on('mouseenter', '.js-cursor-open', function() {
      if (!$events.touching) {
        $el('#cursor').addClass('cursor--open');
      }
    });
    $('body').on('mouseleave', '.js-cursor-open', function() {
      if (!$events.touching) {
        $el('#cursor').removeClass('cursor--open');
      }
    });
    $('body').on('mouseenter', '.js-cursor-close', function() {
      if (!$events.touching) {
        $el('#cursor').addClass('cursor--close');
      }
    });
    $('body').on('mouseleave', '.js-cursor-close', function() {
      if (!$events.touching) {
        $el('#cursor').removeClass('cursor--close');
      }
    });
    document.addEventListener('mousemove', function(e) {
      $cursors.x = e.clientX;
      $cursors.y = e.clientY;
    });
    requestAnimationFrame($cursors.render);
  },

  // ======================================================================
  // RENDER
  // ======================================================================

  render: function() {
    $el('#cursor').css({
      transform: 'translate(' + $cursors.x + 'px, ' + $cursors.y + 'px)'
    });
    requestAnimationFrame($cursors.render);
  }
};
